// extracted by mini-css-extract-plugin
module.exports = {"writePostBtnWrapper":"styles-module__writePostBtnWrapper___3PM_N","writePostBtn":"styles-module__writePostBtn___PHiZ4"};